{
  "version": "2026-10",
  "width": 1200,
  "height": 630,
  "pages": {
    "": "home",
    "vps-standard": "vps-standard",
    "vps-performance": "vps-performance",
    "plesk": "plesk",
    "plesk-dedicated": "plesk-dedicated",
    "dedicated": "dedicated",
    "datacenter": "datacenter",
    "ip-tunnels": "ip-tunnels",
    "antiddos": "antiddos",
    "domains": "domains",
    "ssl": "ssl",
    "workspace": "workspace",
    "fibre": "fibre",
    "telephonie": "telephonie"
  }
}
